/**
 * Tiny module-level pub/sub for app-wide toasts.
 *
 * Only one consumer (the app shell) registers an emitter; non-React layers
 * such as the axios response interceptor in `Http.js` can call
 * `emitGlobalToast(message)` to surface a notification without holding a
 * reference to a React hook. Safe no-op when no emitter is registered yet
 * (e.g. before <App /> mounts or after it unmounts).
 */

let emitter = null;

export const setShowToastEmitter = (fn) => {
  emitter = typeof fn === "function" ? fn : null;
};

export const clearShowToastEmitter = () => {
  emitter = null;
};

export const emitGlobalToast = (
  message,
  type = "error",
  duration = 6000
) => {
  if (!message) return;
  if (emitter) emitter(message, type, null, duration);
};
